import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { HomeComponent } from './modules/home/home.component';
import { MenuComponent } from './modules/menu/menu.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: '',
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'menu',
    component: MenuComponent
  },
  {
    path: 'venta-bonos',
    loadChildren: () => import('./modules/bonos/bonos.module').then(m => m.BonosModule)
  },
  {
    path: 'bono-ges',
    loadChildren: () => import('./modules/bono-ges/bono-ges.module').then(m => m.BonoGesModule)
  },
  {
    path: 'reembolso',
    loadChildren: () => import('./modules/reembolsos/reembolsos.module').then(m => m.ReembolsosModule)
  },
  {
    path: 'pago-cotizaciones',
    loadChildren: () => import('./modules/pago-cotizaciones/detalle-cotizacion.module').then(m => m.DetalleCotizacionModule)
  },
  {
    path: 'certificados',
    loadChildren: () => import('./modules/certificados/certificados.module').then(m => m.CertificadosModule)
  },
  {
    path: 'devolucion-exceso',
    loadChildren: () => import('./modules/devolucion-excesos/devolucion-excesos.module').then(m => m.DevolucionExcesosModule)
  },
  {
    path: 'pago-bonos',
    loadChildren: () => import('./modules/pagobonos/pagobonos.module').then(m => m.PagobonosModule),
    // canActivate: [AuthGuard]
  },
  {
    path: 'licencias',
    loadChildren: () => import('./modules/licencias/licencias.module').then(m => m.LicenciasModule)
  },
  {
    path: '',
    loadChildren: () => import('./modules/ex-clientes/ex-clientes.module').then(m => m.ExClientesModule)
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    preloadingStrategy: PreloadAllModules
  })],
  exports: [RouterModule]
})

export class AppRoutingModule { }
